import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route, withRouter, Redirect } from "react-router";

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { closeSidebar } from "../../actions/navigation";
import Footer from "../Footer/Footer";
import Breadcrumbs from "../Breadbrumbs/Breadcrumbs";

import Dashboard from "../../pages/dashboard/Dashboard";
import Profile from "../../pages/profile/Profile";
import UserListPage from "../Users/list/UsersListPage";
import JenisBantuanListPage from "../Users/list/JenisBantuanListPage";

import PenerimaListPage from "../Users/list/PenerimaListPage";
import PenerimaFormPage from "../Users/form/PenerimaFormPage";
import UploadPenerimaPage from "../Users/form/UploadPenerimaPage";

import UserFormPage from "../Users/form/UserFormPage";

import Notifications from "../../pages/uielements/notifications/Notifications";
import Tables from "../../pages/tables/Tables";

import Navbars from "../../pages/uielements/navbar/Navbars";
import Navs from "../../pages/uielements/navs/Navs";

import BarCharts from "../../pages/charts/bar/BarCharts";
import LineCharts from "../../pages/charts/line/LineCharts";
import PieCharts from "../../pages/charts/pie/PieCharts";
import OtherCharts from "../../pages/charts/other/OtherCharts";

import Login from "../../pages/auth/login/Login";

import AsupanFormPage from "../../pages/tables/form/AsupanFormPage";

import TableProgress from "../../pages/tables/TableProgress";
import BantuanProgressDetailPage from "../../pages/tables/BantuanProgressDetailPage";
import TableProgressSemua from "../../pages/tables/TableProgressSemua";
import TableSK from "../../pages/tables/TableSK";

import s from "./Layout.module.scss";
import TablesKec from "../../pages/tables/TablesKec";
import MapCustomizationPage from "../../pages/maps/MapCustomizationPage";
import CariIndividu from "../../pages/tables/CariIndividu";
import TableSelesaiInput from "../../pages/tables/TableSelesaiInput";
import EvaluasiListPage from "../Users/list/EvaluasiListPage";
import TableSKSelesai from "../../pages/tables/TableSKSelesai";
import AdminListPage from "../Users/list/AdminListPage";
import TableKunci from "../../pages/tables/TableKunci";
import JenisBantuanFormPage from "../Users/form/JenisBantuanFormPage";
import AuditLogsPage from "../../pages/admin/AuditLogsPage";
import BelanjaMaminRekapPage from "../../pages/makanMinum/BelanjaMaminRekapPage";
import BelanjaMaminPdPage from "../../pages/makanMinum/BelanjaMaminPdPage";
import LaporanBulananListPage from "../../pages/makanMinum/LaporanBulananListPage";
import LaporanBulananFormPage from "../../pages/makanMinum/LaporanBulananFormPage";
import MakanMinumDashboardPage from "../../pages/makanMinum/MakanMinumDashboardPage";
import BrandedRouteLoading from "../RouteLoading/BrandedRouteLoading";

const Layout = (props) => {
  const [routeBusy, setRouteBusy] = useState(false);
  const skipFirstPath = useRef(true);
  const timerRef = useRef(null);
  const rafPairRef = useRef({ id1: null, id2: null });

  useEffect(() => {
    if (skipFirstPath.current) {
      skipFirstPath.current = false;
      return;
    }
    setRouteBusy(true);
    const t0 = Date.now();
    const finish = () => {
      const wait = Math.max(0, 200 - (Date.now() - t0));
      timerRef.current = setTimeout(() => setRouteBusy(false), wait);
    };
    rafPairRef.current.id1 = requestAnimationFrame(() => {
      rafPairRef.current.id2 = requestAnimationFrame(finish);
    });
    return () => {
      if (rafPairRef.current.id1 != null) {
        cancelAnimationFrame(rafPairRef.current.id1);
      }
      if (rafPairRef.current.id2 != null) {
        cancelAnimationFrame(rafPairRef.current.id2);
      }
      clearTimeout(timerRef.current);
    };
  }, [props.location.pathname]);

  return (
    <div className={s.root}>
      {props.sidebarOpened && (
        <div
          className={s.sidebarBackdrop}
          onClick={() => props.dispatch(closeSidebar())}
          onKeyDown={(e) => e.key === 'Escape' && props.dispatch(closeSidebar())}
          role="button"
          tabIndex={0}
          aria-label="Tutup menu"
        />
      )}
      <div className={s.wrap}>
        <Header />
        <Sidebar />
        <main className={s.content}>
          <div className={s.contentInner}>
            {routeBusy && <BrandedRouteLoading variant="content" />}
            <Breadcrumbs url={props.location.pathname} />
            <Switch>
            <Route
              path="/template"
              exact
              render={() => <Redirect to="template/dashboard" />}
            />
            <Route path="/template/dashboard" exact component={Dashboard} />
            <Route
              path="/template/user"
              exact
              render={() => <Redirect to={"/template/user/profile"} />}
            />
            <Route path="/template/user/profile" exact component={Profile} />
            <Route
              path="/admin"
              exact
              render={() => <Redirect to="/admin/bantuan" />}
            />
            <Route path="/admin/bantuan" exact component={UserListPage} />
            <Route
              path="/admin/bantuan/jenis"
              exact
              component={JenisBantuanListPage}
            />
            <Route path="/admin/bantuan/new" exact component={UserFormPage} />
            <Route
              path="/admin/bantuan/jenis/new"
              exact
              component={JenisBantuanFormPage}
            />
            <Route
              path="/admin/bantuan/:id/edit"
              exact
              component={UserFormPage}
            />
            <Route
              path="/admin/bantuan/:idView"
              exact
              component={UserFormPage}
            />

            <Route
              path="/admin/bantuan/jenis/:id/edit"
              exact
              component={JenisBantuanFormPage}
            />
            <Route
              path="/admin/bantuan/jenis/:idView"
              exact
              component={JenisBantuanFormPage}
            />

            <Route path="/admin/penerima" exact component={PenerimaListPage} />
            <Route
              path="/admin/penerima/upload"
              exact
              component={UploadPenerimaPage}
            />
            <Route
              path="/admin/penerima/new"
              exact
              component={PenerimaFormPage}
            />
            <Route
              path="/admin/penerima/:id/edit"
              exact
              component={PenerimaFormPage}
            />
            <Route
              path="/admin/penerima/:idView"
              exact
              component={PenerimaFormPage}
            />

            <Route
              path="/template/edit_profile"
              exact
              component={UserFormPage}
            />

            <Route path="/template/desil/desa" exact component={Tables} />
            <Route
              path="/template/desil/kecamatan"
              exact
              component={TablesKec}
            />
            <Route
              path="/template/desil/cari-individu"
              exact
              component={CariIndividu}
            />
            <Route
              path="/template/pengaturan-peta"
              exact
              component={MapCustomizationPage}
            />
            <Route
              path="/template/desil/pengaturan-peta"
              exact
              render={() => <Redirect to="/template/pengaturan-peta" />}
            />

            <Route
              path="/template/progressinput/onprogress"
              exact
              component={TableProgress}
            />
            <Route
              path="/template/progressinput/bantuan-detail"
              exact
              component={BantuanProgressDetailPage}
            />
            <Route
              path="/template/progressinput/semua"
              exact
              component={TableProgressSemua}
            />
            <Route
              path="/template/progressinput/selesai"
              exact
              component={TableSelesaiInput}
            />
            <Route
              path="/template/progressSK/onprogress"
              exact
              component={TableSK}
            />
            <Route
              path="/template/progressSK/selesai"
              exact
              component={TableSKSelesai}
            />

            <Route
              path="/template/evaluasi/inputevaluasi"
              exact
              component={EvaluasiListPage}
            />
            <Route
              path="/admin/kunci/kunciaturan"
              exact
              component={TableKunci}
            />
            <Route path="/admin/listadmin" exact component={AdminListPage} />
            <Route path="/admin/audit-logs" exact component={AuditLogsPage} />

            <Route
              path="/admin/makan-minum/dashboard"
              exact
              component={MakanMinumDashboardPage}
            />
            <Route
              path="/admin/makan-minum"
              exact
              component={BelanjaMaminRekapPage}
            />
            <Route
              path="/admin/makan-minum/belanja-pd"
              exact
              component={BelanjaMaminPdPage}
            />
            <Route
              path="/admin/makan-minum/laporan-bulanan/new"
              exact
              component={LaporanBulananFormPage}
            />
            <Route
              path="/admin/makan-minum/laporan-bulanan/:id/edit"
              exact
              component={LaporanBulananFormPage}
            />
            <Route
              path="/admin/makan-minum/laporan-bulanan"
              exact
              component={LaporanBulananListPage}
            />

            <Route
              path="/template/ui-elements/navbars"
              exact
              component={Navbars}
            />
            <Route path="/template/ui-elements/navs" exact component={Navs} />
            <Route
              path="/template/ui-elements/notifications"
              exact
              component={Notifications}
            />

            <Route
              path="/template/forms"
              exact
              render={() => <Redirect to={"/template/forms/elements"} />}
            />

            <Route
              path="/template/analitik"
              exact
              render={() => (
                <Redirect to={"/template/analitik/miskinekstrim"} />
              )}
            />
            <Route
              path="/template/analitik/penerima"
              exact
              component={LineCharts}
            />
            <Route
              path="/template/analitik/fasilitas"
              exact
              component={PieCharts}
            />
            <Route
              path="/template/analitik/miskinekstrim"
              exact
              component={BarCharts}
            />
            <Route
              path="/template/charts/other"
              exact
              component={OtherCharts}
            />

            <Route path="/template/extra/beranda" exact component={Login} />

            <Route path="*" exact render={() => <Redirect to="/error" />} />
          </Switch>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

Layout.propTypes = {
  sidebarOpened: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
    currentUser: store.auth.currentUser,
  };
}

export default withRouter(connect(mapStateToProps)(Layout));
